/* Stamped review cards: the widget stretches every card in its
 * carousel row to the tallest review. Review bodies are clamped in
 * CSS to six lines; this adds a Read more / Show less control to the
 * ones that were actually cut off, expanding the card in place.
 * The widget renders asynchronously and lays cards out in a carousel
 * after inserting them (and re-renders on sort, search and paging),
 * so cards are re-checked on every DOM change, on a short timer, and
 * on resize until they measure as overflowing.
 */
(() => {
  const widget = document.getElementById('stamped-main-widget');
  if (!widget) return;

  const LABEL_MORE = 'Read more';
  const LABEL_LESS = 'Show less';

  const process = (body) => {
    if (body.nextElementSibling?.classList.contains('vitae-review-more')) return;
    if (!body.clientHeight || body.scrollHeight <= body.clientHeight + 2) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vitae-review-more';
    btn.textContent = LABEL_MORE;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', () => {
      const open = body.classList.toggle('is-expanded');
      btn.textContent = open ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute('aria-expanded', String(open));
    });
    body.insertAdjacentElement('afterend', btn);
  };

  let pending = null;
  const scan = () => {
    pending = null;
    widget.querySelectorAll('.stamped-review-content-body').forEach(process);
  };
  const schedule = () => { if (!pending) pending = requestAnimationFrame(scan); };

  schedule();
  new MutationObserver(schedule).observe(widget, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  [800, 2000, 4000, 8000].forEach((ms) => setTimeout(schedule, ms));
})();
